module.exports = __webpack_public_path__ + "img/img27.65db417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img27.png
// module id = 371
// module chunks = 0